import {
  SurveyVariantEnum,
  WiseOwlIngress,
} from "@twiliointernal/e2-commons-shared-definitions";
import {
  ErrorState,
  SurveyErrorVariantsEnum,
  SurveyContextProps,
} from "../types";

export const noErrorState: ErrorState = {
  error: false,
  type: SurveyErrorVariantsEnum.none,
};

export const defaultSurveyContext: SurveyContextProps = {
  state: {
    chatId: "",
    displayName: "",
    errorState: noErrorState,
    isSurveyEnabled: false,
    isSurveySubmitted: false,
    isSurveyVisible: false,
    ingress: WiseOwlIngress.osc,
    submitFeedbackFailed: false,
    surveyId: "",
    surveyVariant: SurveyVariantEnum.HELP_CENTER_ASSISTANT,
  },
  handlers: {
    handleCancelSurvey: () => ({}),
    handleShowSurvey: () => ({}),
    resetSurveyState: () => ({}),
    setErrorState: () => ({}),
    setSurveySubmitted: () => ({}),
    setSurveyNotSubmitted: () => ({}),
  },
};
